module.exports = __webpack_public_path__ + "static/media/Kujou Sara.f05d8a7e.png";